<template lang="html">
  <!-- ${getStyle()}; -->
  <v-app-bar
    app
    dense
    class="nav-bar"
    :style="{'z-index': zIndexComputed ? '0' : '9999'}"
    >
    <div v-if="$route.name === 'Simulation'">
      <img v-if="this.$vuetify.theme.dark" src="/static/takting_white.svg" alt="TAKT.ing GmbH" height="35vh" width="35vh" style="margin-top:10px;">
      <img v-else src="/static/takting_black.svg" alt="TAKT.ing GmbH" height="35vh" width="35vh" style="margin-top:10px;">
    </div>
    <router-link v-else :to="isLoggedIn ? '/home' : '/'" class="no-style">
      <img v-if="this.$vuetify.theme.dark" src="/static/takting_white.svg" alt="TAKT.ing GmbH" height="35vh" width="35vh" style="margin-top:10px;">
      <img v-else src="/static/takting_black.svg" alt="TAKT.ing GmbH" height="35vh" width="35vh" style="margin-top:10px;">
    </router-link>
    <slot name="buttonsLeft"/>
    <v-spacer/>
    <slot name="tools"/>
    <slot name="buttonsMiddle"/>
    <slot name="editbtn"/>
    <slot name="ifc_upload"/>
    <v-spacer/>
    <slot name="taktSlider"/>
    <slot name="projectStatus"/>
    <slot name="switch"/>
    <!-- <slot name="projectMessages"/> -->
    <slot name="buttonsRight"/>
  </v-app-bar>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  data: () => ({
    version_number: '',
    // pixel_ratio: 1,
  }),
  created() {
    // window.matchMedia(`(resolution: ${window.devicePixelRatio}dppx)`).addListener(this.updatePixelRatio());
    // this.updatePixelRatio()
    // window.addEventListener( "resize", this.updatePixelRatio())

    // let mqString = `(resolution: ${window.devicePixelRatio}dppx)`;
    //
    // const updatePixelRatio = () => {
    //   let pr = window.devicePixelRatio;
    // }
    //
    // updatePixelRatio();
    //
    // matchMedia(mqString).addListener(updatePixelRatio);

  },
  computed: {
    ...mapGetters('Auth', [
      'isLoggedIn'
    ]),
    zIndexComputed() {
      const substringsToCheck = ['ImagesZoom','Editor','SelectTaktPlan','TaktPlanWorkPackageMaterialStepMaterials']; // Your array of substrings
      const matchedEntries = this.$route.matched;

      for (const entry of matchedEntries) {
        const name = entry.name;

        for (const substring of substringsToCheck) {
          if (name.includes(substring)) {
            return true; // If any matched entry contains the substring, set zIndexComputed to true
          }
        }
      }
      return false; // If no matched entry contains any of the substrings, set zIndexComputed to false
    }
  },
  methods: {
    // updatePixelRatio() {
    //   this.pixel_ratio = window.devicePixelRatio
    // },
    // getStyle() {
    // return `zoom: ${1/window.devicePixelRatio}`
    // }
  },
}
</script>

<style>
  .no-style {
    text-decoration: none;
    /* color: white; */
  }
  .nav-bar {
    /* zoom: 1; */
  }
</style>
